import { Product } from './product';
import { ChangedHistoryModel } from './changed-history';
import { PaymentHistoryModel } from './payment-history';
import { OrderComplainModel } from './order-complain';

export class Order {
    public id!: number;
    public createdDate!: string;
    public boughtDate!: string;
    public transactionCode!: string;
    public shopDeliverDate!: string;
    public storeCNImDate!: string;
    public storeCNExDate!: string;
    public storeVNImDate!: string;
    public storeVNExDate!: string;
    public completedDate!: string;
    public deposit!: number;
    public minDeposit!: number;
    public shopName!: string;
    public userName!: string;
    public site!: string;
    public status!: number;
    public statusDetail!: any;
    public totalAmountVND!: number;
    public uId!: number;
    public imageOrigin!: string;
    public isChecked!: boolean;
    public safeLevelID!: any;
    public safeLevelWeightAmount!: number;
    public safeLevelVolumeAmount!: number;

    // Extands Detail
    public amountCNY!: number;
    public amountVND!: number;
    public buyerID!: number;
    public createdBy!: any;
    public depositDate!: string;
    public exchangeRate!: number;
    public feeBuy!: number;
    public feeBuyAmount!: number;
    public feeBuyDiscount!: number;
    public feeOther!: number;
    public feeOtherNote!: string;
    public feeShipCN!: number;
    public feeShipCNVND!: number;
    public feeShipVN!: number;
    public totalOtherFee!: number;
    public feeWeight!: number;
    public feeWeightAmount!: number;
    public feeWeightDiscount!: number;
    public guaranteeAmount!: number;
    public guaranteeAmountVND!: number;
    public isCheck!: boolean;
    public isFragileGoods!: boolean;
    public isFoam!: boolean;
    public isFast!: boolean;
    public modifiedBy!: number;
    public modifiedDate!: string;
    public note!: string;
    public feeShipType!: number;
    public orderWeight!: number;
    public receivePlaceID!: number;
    public chinaStoreID!: number;
    public receivePlaceDetail!: any;
    public chinaStoreDetail!: any;
    public salerId!: number;
    public shopId!: number;
    public fragileFee!: number;
    public fragileFeeVND!: number;
    public foamFee!: number;
    public foamFeeVND!: number;
    public checkFeeType!: number;
    public checkFee!: number;
    public checkFeeVND!: number;
    public fastFee!: number;
    public fastFeeVND!: number;
    public surcharge!: number;
    public totalRealAmount!: number;
    public totalRealAmountCNY!: number;
    public discountVND!: number;
    public voucherAmount!: number;
    public quotationId!: number;

    public products: Product[] = [];
    public changedHistories!: ChangedHistoryModel[];
    public paymentHistory!: PaymentHistoryModel[];
    public orderComplains!: OrderComplainModel[];
}
